/**
 * todo.js — Vuex module: TODO list (LEGACY TEMPLATE)
 *
 * ⚠️  Module ini adalah BAWAAN TEMPLATE Velzon dan TIDAK terpakai di
 * Portal IHC. Bisa dihapus kalau yakin tidak ada komponen lain yang
 * konsumsi `todo/todos`.
 *
 * Fungsi (legacy template):
 * - fetch list todo dari endpoint demo `jsonplaceholder.typicode.com`
 * - simpan ke state untuk ditampilkan di halaman demo
 *
 * API:
 * - GET https://jsonplaceholder.typicode.com/todos  (endpoint demo eksternal)
 *
 * NOTE: Kalau sudah pasti tidak dipakai, hapus file ini supaya tidak
 * menambah bundle size. Vuex auto-register di modules/index.js akan
 * otomatis stop register module yang file-nya dihapus.
 */
import axios from "axios";

export const state = {
    todos: [],
};

export const getters = {
    todos: state => state.todos,
};

export const mutations = {
    setTodos(state, newValue) {
        state.todos = newValue
    },
};

export const actions = {
    fetchTodos({ commit }) {
        axios.get('https://jsonplaceholder.typicode.com/todos').then(res => {
            commit('setTodos', res.data)
        })
    },
};
